import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

import {ref,Ref,watch,onMounted,nextTick} from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { useStore } from '@/store';
import {TabType} from './types'
import cache from '@/utils/cache'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const editableTabsValue: Ref<string> = ref("");
const editableTabs:Ref<TabType[]> = ref([]);
const getEditTabs = (route: any ={})=> {
    if(!route.path.startsWith('/redirect')) {
        const flag = editableTabs.value.some(item => item.path == route.path);
        if(!flag) {
            editableTabs.value.push({path: route.path,title: route.meta.title});
        }
    }
    
}
getEditTabs(route);

watch(() => route.path,() => {
    editableTabsValue.value = route.path;
    getEditTabs(route);
})

const handleClick = (event: any = {}) => {
    router.push({path: event.props.name});
    store.commit('login/changeActiveRouter',event.props.name);
}

const hanleRemove = (name: string) => {
    // if(name == '/dashboard') {
    //     return ;
    // }
    if(editableTabs.value.length == 1) {
        return;
    }
    let index = editableTabs.value.findIndex(menu => menu.path == name);
    let activeIndex = index == 0 ? index + 1 : index -1;
    //如果删除的是当前页
    // if(editableTabsValue.value == name) { 
    //     activeIndex = index - 1;
    //     if(editableTabs.value[activeIndex]) {
    //         router.push(editableTabs.value[activeIndex].path)
    //         editableTabsValue.value = editableTabs.value[activeIndex].path;
    //     }  
    // }
    router.push(editableTabs.value[activeIndex].path)
    editableTabsValue.value = editableTabs.value[activeIndex].path;
    store.commit('login/changeActiveRouter',editableTabs.value[activeIndex].path)
    editableTabs.value.splice(index,1);

}

//刷新缓存数据
const refresh = () => {
    (window as any).addEventListener('beforeunload',() => {
        cache.setCache('editableTabs',editableTabs.value);
        cache.setCache('editableTabsValue',editableTabsValue.value)
    })

    let session = cache.getCache('editableTabs');
    if(session) { 
        editableTabs.value = session;
    }
    
    editableTabsValue.value = cache.getCache('editableTabsValue') || '/dashboard';
}

//刷新保存数据
onMounted(() => {
    refresh();
})

//工具栏显示
const contextVisible = ref<boolean>(false);

//当前的路由
const currentPath = ref('');

//工具栏位置
const left = ref(0);
const top = ref(0);

//鼠标右键事件
const openContextMenu = (event: any) => {
    if(event.srcElement.id) {
        //当前路由path
        currentPath.value =  event.srcElement.id.split('-')[1];
        contextVisible.value = true;
        left.value = event.clientX + 40;
        top.value = event.clientY + 30;
    }

}

//刷新页面
const refreshSelectedTag = () => {
    let index = editableTabs.value.findIndex(item => item.path == currentPath.value);
    // if(index > -1) {
    //     editableTabs.value.splice(index,1);
    // }
    editableTabs.value.splice(index,1);
    router.replace({path:'/redirect' +  currentPath.value});
    contextVisible.value = false;
}

//关闭所有
const closeAllTags = () => {
    for(let i = 0;i < editableTabs.value.length;i++) {
        if(editableTabs.value[i].path == '/dashboard') {
            continue;
        }
        editableTabs.value.splice(i,1);
        i--;
    }
    router.replace({path: '/'});
    contextVisible.value = false;
}

//关闭左边
const closeLeftTags = () => {
    let index = editableTabs.value.findIndex(item => item.path == currentPath.value);
    editableTabs.value.splice(0,index);
    editableTabsValue.value = currentPath.value;
    contextVisible.value = false;
}

//关闭右边
const closeRightTags = () => {
    let index = editableTabs.value.findIndex(item => item.path == currentPath.value);
    editableTabs.value.splice(index + 1);
    editableTabsValue.value = currentPath.value;
    contextVisible.value = false;
}

//关闭其他
const closeOtherTags = () => {
    for(let i = 0;i < editableTabs.value.length;i++) {
        if(editableTabs.value[i].path == currentPath.value) {
            
            continue;
        }
        editableTabs.value.splice(i,1);
        i--;
    }
    editableTabsValue.value = currentPath.value;
    contextVisible.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, {
      modelValue: editableTabsValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editableTabsValue).value = $event)),
      type: "card",
      class: "demo-tabs",
      onTabClick: handleClick,
      onTabRemove: hanleRemove,
      onContextmenu: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openContextMenu($event)), ["prevent"]))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableTabs.value, (item) => {
          return (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.path,
            label: item.title,
            name: item.path,
            closable: ""
          }, null, 8, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createElementVNode("ul", {
      style: _normalizeStyle({left: left.value + 'px',top: top.value + 'px'}),
      class: "contextmenu"
    }, [
      _createElementVNode("li", { onClick: closeAllTags }, "关闭所有"),
      _createElementVNode("li", { onClick: closeOtherTags }, "关闭其他")
    ], 4), [
      [_vShow, contextVisible.value]
    ])
  ], 64))
}
}

})